/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enumerates the configurations for solar water heating within a property, indicating the level of detail known about the system.
 */
export type SolarwaterHeatingConfigurationV0 = 'None' | 'DetailsUnknown' | 'DetailsKnown';

export const SolarwaterHeatingConfigurationV0 = {
    None: 'None' as SolarwaterHeatingConfigurationV0,
    DetailsUnknown: 'DetailsUnknown' as SolarwaterHeatingConfigurationV0,
    DetailsKnown: 'DetailsKnown' as SolarwaterHeatingConfigurationV0
};

